<template>
  <div>
    <div class="card">
      <div class="card-header">
        <h4 class="card-header-title">
          {{ $t('components.employees.employeeSalaries') }}
        </h4>
        <router-link
          class="btn btn-sm btn-primary"
          :to="'/employeesSalaries/create?employee_id=' + $route.params.id"
          v-if="$checkRole('employees_salaries_add')"
        >
          <i class="fas fa-plus"></i>
          {{ $t('components.customersInvoices.addition') }}
        </router-link>
      </div>
      <indexTable
        :searchText="$t('employeesSalaries.SearchForASalary')"
        :emptyTableText="$t('employeesSalaries.ThereAreNoPaychecks')"
        :filter="{ employee_id: $route.params.id }"
        :withoutCard="true"
        :emptyTableSubText="$t('allerts.TryAddingSomeItemsToTheTableAndTryAgain')"
        :cloumns="[
          {
            column: 'code',
            title: $t('employeesSalaries.Salary'),
            type: 'mainLink',
            sort: true
          },
          {
            column: 'employee_id',
            title: $t('employeesSalaries.functionary'),
            type: 'link',
            to: 'employee',
            sort: true,
            link: true
          },
          {
            column: 'date',
            title: $t('employeesSalaries.date'),
            type: 'text',
            sort: true
          },
          {
            column: 'description',
            title: $t('employeesSalaries.thatsAbout'),
            type: 'text',
            sort: true
          },
          {
            column: 'notes',
            title: $t('employeesSalaries.note'),
            type: 'text',
            sort: true
          },
          {
            column: 'cost',
            title: $t('employeesSalaries.cost'),
            type: 'text',
            sort: true
          },

          {
            column: 'options',
            title: $t('employeesSalaries.Settings'),
            type: 'options',
            options: [
              { name: 'show' },
              {
                name: 'edit',
                role: $checkRole('employees_salaries_edit')
              },
              { name: 'download', role: true },
              {
                name: 'delete',
                role: $checkRole('employees_salaries_delete')
              }
            ]
          }
        ]"
        :deleteText="{
          attention: $t('allerts.Attention'),
          areYouReallySureToDeleteTheItem: $t('allerts.areYouReallySureToDeleteTheItem'),
          close: $t('allerts.close'),
          confirm: $t('allerts.confirm'),
          loading: $t('allerts.loading')
        }"
      />
    </div>
  </div>
</template>
<script>
import indexTable from '@/elements/index/indexTable.vue'
export default {
  data() {
    return {
      path: '/employeesSalaries'
    }
  },
  components: {
    indexTable
  }
}
</script>
